import { Routes } from '@angular/router';
import { DashboardComponent } from './ui/dashboard/dashboard.component';
import { LessonComponent } from './ui/lesson/lesson.component';
import { CourseManagerDashboardComponent } from './ui/course-manager-dashboard/course-manager-dashboard.component';
import { LessonEditComponent } from './ui/lesson-edit/lesson-edit.component';
import { ResetPasswordPageComponent } from './ui/reset-password-page/reset-password-page.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'lesson/:id', component: LessonComponent
      },
      {
        path: 'course-manager/dashboard',
        component: CourseManagerDashboardComponent
      },
      {
        path: 'lesson-edit/:id', component: LessonEditComponent
      },
      { 
        path: 'reset-password', component: ResetPasswordPageComponent 
      }
];
